import { z } from "zod";

export const featuresSchema = z.record(
  z.string(),
  z.object({ defaultValue: z.any() }),
);

export type Features = z.infer<typeof featuresSchema>;
